import { render, staticRenderFns } from "./ApiScope.vue?vue&type=template&id=06c833de&scoped=true"
import script from "./ApiScope.vue?vue&type=script&lang=js"
export * from "./ApiScope.vue?vue&type=script&lang=js"
import style0 from "./ApiScope.vue?vue&type=style&index=0&id=06c833de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c833de",
  null
  
)

export default component.exports